import { __assign, __read, __spread } from "tslib";
import React, { useMemo, forwardRef, useRef, useCallback } from "react";
import { FixedSizeList, VariableSizeList, } from "react-window";
import { useConfig } from "../util";
import { mergeRefs } from "../_util/merge-refs";
var defaultItemHeight = 45;
export var TableVirtualizedBody = forwardRef(function TableVirtualizedBody(_a, ref) {
    var tableBoxStyle = _a.tableBoxStyle, onScrollCapture = _a.onScrollCapture, onScrollBottom = _a.onScrollBottom, height = _a.height, _b = _a.itemHeight, itemHeight = _b === void 0 ? defaultItemHeight : _b, records = _a.records, renderRecord = _a.renderRecord, getRowKey = _a.getRowKey, topTip = _a.topTip, bottomTip = _a.bottomTip, expandable = _a.expandable;
    var classPrefix = useConfig().classPrefix;
    var bodyRef = useRef(null);
    var OuterElement = useMemo(function () {
        return forwardRef(function (props, ref) {
            return (React.createElement("div", __assign({}, props, { className: classPrefix + "-table__body", ref: ref, onScrollCapture: onScrollCapture })));
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var InnerElement = useMemo(function () {
        return forwardRef(function (_a, ref) {
            var _b = _a.style, style = _b === void 0 ? {} : _b, children = _a.children;
            return (React.createElement("table", { ref: ref, className: classPrefix + "-table__box", style: __assign(__assign(__assign({}, (tableBoxStyle || {})), style), { maxHeight: undefined }) },
                React.createElement("tbody", null, children)));
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tableBoxStyle]);
    var getItemKey = useCallback(function (index, data) {
        if (data[index].type === "top-tip") {
            return "__TABLE_TOP_TIP__";
        }
        if (data[index].type === "bottom-tip") {
            return "__TABLE_BOTTOM_TIP__";
        }
        if (expandable) {
            return data[index].row.key;
        }
        return getRowKey(data[index].row, index);
    }, [expandable, getRowKey]);
    var items = useMemo(function () {
        // 此时要预先渲染行计算总数
        if (expandable) {
            var recordRows_1 = [];
            records.map(renderRecord).forEach(function (rows) {
                rows.forEach(function (r) { return recordRows_1.push(r); });
            });
            return __spread([
                { type: "top-tip", row: topTip }
            ], recordRows_1.map(function (r) { return ({ type: "record", row: r }); }), [
                { type: "bottom-tip", row: bottomTip },
            ]).filter(function (i) { return !!i.row; });
        }
        return __spread([
            { type: "top-tip", row: topTip }
        ], records.map(function (r) { return ({ type: "record", row: r }); }), [
            { type: "bottom-tip", row: bottomTip },
        ]).filter(function (i) { return !!i.row; });
    }, [bottomTip, expandable, records, renderRecord, topTip]);
    var Row = useCallback(function (_a) {
        var data = _a.data, index = _a.index, style = _a.style;
        if (data[index].type === "top-tip" || data[index].type === "bottom-tip") {
            return data[index].row;
        }
        // 此时行已预先渲染计算
        if (expandable) {
            return React.cloneElement(data[index].row, {
                style: __assign(__assign({}, style), { display: "flex" }),
            });
        }
        return renderRecord(data[index].row, index).map(function (row) {
            return React.cloneElement(row, {
                style: __assign(__assign({}, style), { display: "flex" }),
            });
        });
    }, [expandable, renderRecord]);
    var getItemHeight = useCallback(function (index) {
        if (typeof itemHeight !== "function") {
            return itemHeight;
        }
        var offset = items[0].type === "top-tip" ? 1 : 0;
        if (items[index].type === "top-tip" ||
            items[index].type === "bottom-tip") {
            return defaultItemHeight;
        }
        return itemHeight(items[index].row, index - offset);
    }, [itemHeight, items]);
    function handleScroll(props) {
        var itemsSize = items.reduce(function (p, _, index) {
            return p +
                (typeof itemHeight === "function" ? getItemHeight(index) : itemHeight);
        }, 0);
        if (onScrollBottom) {
            if (bodyRef.current && itemsSize > height) {
                var _a = bodyRef.current, scrollHeight = _a.scrollHeight, scrollTop = _a.scrollTop, clientHeight = _a.clientHeight;
                if (scrollHeight <= Math.ceil(clientHeight + scrollTop + 1)) {
                    onScrollBottom(props);
                }
            }
        }
    }
    if (typeof itemHeight === "function") {
        return (React.createElement(VariableSizeList, { outerRef: mergeRefs(ref, bodyRef), outerElementType: OuterElement, innerElementType: InnerElement, height: height, width: "100%", itemSize: function (index) { return getItemHeight(index); }, itemCount: items.length, itemData: items, onScroll: handleScroll, itemKey: getItemKey }, Row));
    }
    return (React.createElement(FixedSizeList, { outerRef: mergeRefs(ref, bodyRef), outerElementType: OuterElement, innerElementType: InnerElement, height: height, width: "100%", itemSize: itemHeight, itemCount: items.length, itemData: items, itemKey: getItemKey, onScroll: handleScroll }, Row));
});
TableVirtualizedBody.displayName = "TableVirtualizedBody";
//# sourceMappingURL=TableVirtualizedBody.js.map